// TODO: Localizition Guide http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
// TODO: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones

const getChoiceIndex = function (choice, choicesLength) {
  if (choice === 0) {
    return 0
  }

  const teen = choice > 10 && choice < 20
  const endsWithOne = choice % 10 === 1
  if (!teen && endsWithOne) {
    return 1
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2
  }

  return choicesLength < 4 ? 2 : 3
}

/**
  day
  dayperiod
  era
  hour
  literal
  minute
  month
  second
  timezonename
  weekday
  year

  year?: 'numeric' | '2-digit',
  month?: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long',
  day?: 'numeric' | '2-digit',
  hour?: 'numeric' | '2-digit',
  minute?: 'numeric' | '2-digit',
  second?: 'numeric' | '2-digit',
  weekday?: 'narrow' | 'short' | 'long',
  hour12?: boolean,
  era?: 'narrow' | 'short' | 'long',
  timeZone?: string, // IANA time zone
  timeZoneName?: 'short' | 'long',
  localeMatcher?: 'lookup' | 'best fit',
  formatMatcher?: 'basic' | 'best fit'


  let format = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: 'Europe/Kiev',
  }
  let formatter = $vm0.$i18n._dateTimeFormatters = new Intl.DateTimeFormat('uk', format)
  formatter.format(new Date())

 */
const dateFormat = {
  shortMonth: {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    timeZone: 'Europe/Kiev',
  },
  longMonth: {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Kiev',
  },
  shortDate: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Kiev',
  },
  weekdayShort: {
    weekday: 'short',
    timeZone: 'Europe/Kiev',
  },
  weekdayLong: {
    weekday: 'long',
    timeZone: 'Europe/Kiev',
  },
  longDate: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Kiev',
  },
  time: {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Kiev',
  },
  longTime: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    millisecond: '3-digit',
    timeZone: 'Europe/Kiev',
  },
}

/*
  <i18n-n tag="span" :value="100000" format="currency" locale="uk-UA"></i18n-n>
  <i18n-n tag="span" :value="100000" format="currency" locale="ru-RU"></i18n-n>


  <p>{{ $n(10000, 'currency') }}</p>
  <p>{{ $n(10000, 'currency', 'ja-JP') }}</p>
  <p>{{ $n(10000, 'currency', 'ja-JP', { useGrouping: false }) }}</p>
  <p>{{ $n(987654321, 'currency', { notation: 'compact' }) }}</p>
  <p>{{ $n(0.99123, 'percent') }}</p>
  <p>{{ $n(0.99123, 'percent', { minimumFractionDigits: 2 }) }}</p>
  <p>{{ $n(12.11612345, 'decimal') }}</p>
  <p>{{ $n(12145281111, 'decimal', 'ja-JP') }}</p>

  <p>$10,000.00</p>
  <p>￥10,000</p>
  <p>￥10000</p>
  <p>$988M</p>
  <p>99%</p>
  <p>99.12%</p>
  <p>12.12</p>
  <p>12,145,000,000</p>

  NumberFormatOptions = {
  style?: 'decimal' | 'currency' | 'percent', // Стиль форматирования: десятичный, валютный или процентный
  currency?: string, // ISO 4217 currency codes - код валюты (UAH, USD, EUR и т.д.)
  currencyDisplay?: 'symbol' | 'code' | 'name', // Отображение валюты: символ ($), код (USD) или название (доллар США)
  useGrouping?: boolean, // Использовать группировку разрядов (1,000,000 vs 1000000)
  minimumIntegerDigits?: number, // Минимальное количество цифр в целой части (дополняется нулями слева)
  minimumFractionDigits?: number, // Минимальное количество цифр после запятой (дополняется нулями справа)
  maximumFractionDigits?: number, // Максимальное количество цифр после запятой (обрезается)
  minimumSignificantDigits?: number, // Минимальное количество значащих цифр
  maximumSignificantDigits?: number, // Максимальное количество значащих цифр
  localeMatcher?: 'lookup' | 'best fit', // Алгоритм подбора локали:
  formatMatcher?: 'basic' | 'best fit' // Алгоритм подбора формата:
  // 'basic' - использует только стандартные поддерживаемые форматы
  // 'best fit' - может использовать дополнительные алгоритмы и эвристики
  // Пример для currency с minimumFractionDigits: 3:
  // 'basic': строго 3 знака после запятой (10.000 UAH)
  // 'best fit': может адаптировать под локаль (10,00 грн для uk-UA)
};

*/

const getNumberFormat = (lang) => {
  let currency = 'UAH'
  const decimal = '.'
  const thousands = ' '
  if (lang === 'en') {
    currency = 'USD'
  }
  return {
    currency: {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      decimal,
      thousands,
      grouping: 3
    },
    currencyName: {
      style: 'currency',
      currency,
      currencyDisplay: 'name',
      decimal,
      thousands,
      grouping: 3
    },
    decimal: {
      style: 'decimal',
      delimiter: decimal,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    decimal_5: {
      style: 'decimal',
      delimiter: decimal,
      minimumFractionDigits: 2,
      maximumFractionDigits: 5
    },
    percent: {
      style: 'percent',
      delimiter: decimal,
      useGrouping: false
    }
  }
}

export default {
  getChoiceIndex(locale) {
    if (locale === 'uk') {
      return getChoiceIndex
    }
    return null
  },
  dateTimeFormats: {
    uk: dateFormat,
    en: dateFormat,
  },
  numberFormats: {
    uk: getNumberFormat('uk'),
    en: getNumberFormat('en'),
  },
}
